// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@400;500);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ndD2Hv255jMaUjfb2tYY {
  position: fixed;
  left: 50%;
  bottom: 20px; /* Position it at the bottom of the window */
  transform: translateX(-50%); /* Center it horizontally */
  z-index: 9; /* Lower z-index to be below modals */
}
.ndD2Hv255jMaUjfb2tYY button {
  padding: 18px 14px; /* Adjusted padding to keep icon centered */
  border-radius: 10px; /* Rounded corners on all sides since it's centered */
  height: 60px;
  /* When toggle is open, don't expand width and don't show text on hover */
}
.ndD2Hv255jMaUjfb2tYY button.uSRJ0eD0npEBtIgomBuR {
  display: none;
}

.PY6eGbwQM34QBB8IWa9B {
  position: fixed;
  left: 50%;
  bottom: 20px; /* Position it above the toggle button */
  transform: translateX(-50%); /* Center it horizontally */
  z-index: 8; /* Lower z-index to be below modals */
  min-width: 450px;
  width: 50vw;
  overflow-y: auto;
  background-color: rgba(40, 40, 40, 0.8);
  backdrop-filter: blur(10px);
  border-radius: 8px; /* Rounded corners on all sides */
  border: 1px solid #3d3d3d;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.PY6eGbwQM34QBB8IWa9B .i_yNxSMXg3jy8JH7kLbJ {
  display: flex;
  align-items: center;
  padding: 18px 15px;
  border-bottom: 1px solid #474747;
  position: relative;
}
.PY6eGbwQM34QBB8IWa9B .i_yNxSMXg3jy8JH7kLbJ .vn0Z4bNtPCd71HvPvRbR {
  font-weight: 1000;
  color: #fff;
  font-size: 24px;
  display: flex;
  align-items: center;
  gap: 12px; /* Add space between text and icon */
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  justify-content: center;
  pointer-events: none; /* Allow clicks to pass through to elements below */
}
.PY6eGbwQM34QBB8IWa9B .i_yNxSMXg3jy8JH7kLbJ .vn0Z4bNtPCd71HvPvRbR svg {
  pointer-events: none; /* Ensure icon doesn't capture clicks */
}
.PY6eGbwQM34QBB8IWa9B .i_yNxSMXg3jy8JH7kLbJ .Fk4ZtKavXiNu2dwJ_N2g {
  background: conic-gradient(from 0deg, #ff00cc, #ff00cc, #ff9900, #ff9900, #9900ff, #ff00cc);
  color: white;
  font-weight: bold;
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  white-space: nowrap;
}
.PY6eGbwQM34QBB8IWa9B .i_yNxSMXg3jy8JH7kLbJ .Fk4ZtKavXiNu2dwJ_N2g:hover {
  opacity: 0.8;
}
.PY6eGbwQM34QBB8IWa9B .i_yNxSMXg3jy8JH7kLbJ .mhstdJXT57e5ZIF0SKVw {
  display: flex;
  gap: 8px;
  margin-left: auto; /* Push to the right side */
}
.PY6eGbwQM34QBB8IWa9B .i_yNxSMXg3jy8JH7kLbJ .mhstdJXT57e5ZIF0SKVw .pfn6leN0LQiC25LxR1ry {
  background: none;
  border: none;
  cursor: pointer;
  color: #777;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 4px;
}
.PY6eGbwQM34QBB8IWa9B .i_yNxSMXg3jy8JH7kLbJ .mhstdJXT57e5ZIF0SKVw .pfn6leN0LQiC25LxR1ry:hover {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.1);
}
.PY6eGbwQM34QBB8IWa9B .i_yNxSMXg3jy8JH7kLbJ .mhstdJXT57e5ZIF0SKVw .pfn6leN0LQiC25LxR1ry:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.PY6eGbwQM34QBB8IWa9B .i_yNxSMXg3jy8JH7kLbJ .mhstdJXT57e5ZIF0SKVw .nOBt54z9z6rhSpkXl9pR {
  background: none;
  border: none;
  cursor: pointer;
  color: #777;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s ease;
}
.PY6eGbwQM34QBB8IWa9B .i_yNxSMXg3jy8JH7kLbJ .mhstdJXT57e5ZIF0SKVw .nOBt54z9z6rhSpkXl9pR:hover {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.1);
}
.PY6eGbwQM34QBB8IWa9B .Puob5KTyHUxauLdnwFMc {
  max-height: 50vh;
  overflow-y: auto;
  padding: 10px 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.PY6eGbwQM34QBB8IWa9B .Qd2Bcj_mr_4KIGSaSbYk {
  align-self: center;
  padding: 8px 12px;
  color: #777;
  font-style: italic;
}
.PY6eGbwQM34QBB8IWa9B .KIgWYQKpNYZJz4JsOC6M {
  display: flex;
  justify-content: flex-end;
  padding: 0 15px 8px;
}
.PY6eGbwQM34QBB8IWa9B .VTY2fSdm1pm7dRzrjNNF {
  display: flex;
  gap: 10px;
  margin-top: 4px;
}
.PY6eGbwQM34QBB8IWa9B .N7ljWca7xPK98VWJFS6P {
  background: none;
  border: 1px solid #7d7d7d;
  border-radius: 4px;
  color: #777;
  padding: 6px 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}
.PY6eGbwQM34QBB8IWa9B .N7ljWca7xPK98VWJFS6P:hover {
  background-color: #444;
  color: #fff;
  border-color: #777;
}
.PY6eGbwQM34QBB8IWa9B .lraVT_jJPAhnCGn1ChWI {
  font-size: 12px;
  color: #777;
  font-style: italic;
  padding: 8px 0;
}
.PY6eGbwQM34QBB8IWa9B .e1x3XsUIgyZXD_QOB50m {
  max-width: 90%;
  padding: 8px 12px;
  border-radius: 12px;
  color: #fff;
}
.PY6eGbwQM34QBB8IWa9B .e1x3XsUIgyZXD_QOB50m.XM6n1YQJaSlAM5MklYwe {
  align-self: flex-end;
  background-color: #6a4ac3;
}
.PY6eGbwQM34QBB8IWa9B .e1x3XsUIgyZXD_QOB50m.FgjQogkx9AwKL5ABxXAp {
  align-self: flex-start;
  background-color: #444;
  width: 100%;
  border-left: 3px solid #ffc107;
  position: relative;
}
.PY6eGbwQM34QBB8IWa9B .e1x3XsUIgyZXD_QOB50m.FgjQogkx9AwKL5ABxXAp.DjScRZmvL98UHvStTiU8 {
  border-left-color: #28a745;
}
.PY6eGbwQM34QBB8IWa9B .e1x3XsUIgyZXD_QOB50m.FgjQogkx9AwKL5ABxXAp.HT4UXRcnyFzp57UHThem {
  border-left-color: #dc3545;
}
.PY6eGbwQM34QBB8IWa9B .e1x3XsUIgyZXD_QOB50m.FgjQogkx9AwKL5ABxXAp .IENmtTuhJMMoD8ojAFi2 {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 1.2em;
}
.PY6eGbwQM34QBB8IWa9B .e1x3XsUIgyZXD_QOB50m.FgjQogkx9AwKL5ABxXAp .IENmtTuhJMMoD8ojAFi2 .Ro_god6fZZEqzoV_Cag7 {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 8px;
  background-color: #ffc107;
}
.PY6eGbwQM34QBB8IWa9B .e1x3XsUIgyZXD_QOB50m.FgjQogkx9AwKL5ABxXAp .IENmtTuhJMMoD8ojAFi2 .Ro_god6fZZEqzoV_Cag7.DjScRZmvL98UHvStTiU8 {
  background-color: #28a745;
}
.PY6eGbwQM34QBB8IWa9B .e1x3XsUIgyZXD_QOB50m.FgjQogkx9AwKL5ABxXAp .IENmtTuhJMMoD8ojAFi2 .Ro_god6fZZEqzoV_Cag7.HT4UXRcnyFzp57UHThem {
  background-color: #dc3545;
}
.PY6eGbwQM34QBB8IWa9B .e1x3XsUIgyZXD_QOB50m.FgjQogkx9AwKL5ABxXAp .IENmtTuhJMMoD8ojAFi2 .TLZG_Wk4hQlqAxreJWGI {
  margin-left: auto;
  background-color: #6439df;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 0.8em;
  cursor: pointer;
}
.PY6eGbwQM34QBB8IWa9B .e1x3XsUIgyZXD_QOB50m.FgjQogkx9AwKL5ABxXAp .IENmtTuhJMMoD8ojAFi2 .TLZG_Wk4hQlqAxreJWGI:hover {
  background-color: #5b37c0;
}
.PY6eGbwQM34QBB8IWa9B .e1x3XsUIgyZXD_QOB50m.FgjQogkx9AwKL5ABxXAp .IENmtTuhJMMoD8ojAFi2 .TLZG_Wk4hQlqAxreJWGI:focus {
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.PY6eGbwQM34QBB8IWa9B .e1x3XsUIgyZXD_QOB50m.FgjQogkx9AwKL5ABxXAp .IENmtTuhJMMoD8ojAFi2 .TLZG_Wk4hQlqAxreJWGI:active {
  background-color: #543e79;
}
.PY6eGbwQM34QBB8IWa9B .e1x3XsUIgyZXD_QOB50m.FgjQogkx9AwKL5ABxXAp .iSAZRnvlo9lr7XxWA223 {
  margin-top: 8px;
  padding: 8px;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  font-family: monospace;
  font-size: 1.2em;
  overflow-x: auto;
}
.PY6eGbwQM34QBB8IWa9B .e1x3XsUIgyZXD_QOB50m.HCNJGaL5OeiE5BKGyreE {
  align-self: flex-start;
  background-color: #222;
  width: 100%;
  position: relative;
}
.PY6eGbwQM34QBB8IWa9B .e1x3XsUIgyZXD_QOB50m.HCNJGaL5OeiE5BKGyreE .d0cMPLprvuxq6fn1bWXB {
  position: absolute;
  top: 3px;
  right: -45px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid #6a4ac3;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.PY6eGbwQM34QBB8IWa9B .e1x3XsUIgyZXD_QOB50m.HCNJGaL5OeiE5BKGyreE .d0cMPLprvuxq6fn1bWXB svg {
  width: 24px;
  height: 24px;
  color: #fff;
}
.PY6eGbwQM34QBB8IWa9B .nofwYrL3vQdajEnlJsL0 {
  display: flex;
  flex-direction: column;
  padding: 10px 15px;
  border-top: 1px solid #474747;
  gap: 8px;
  background-color: rgb(50, 50, 50);
}
.PY6eGbwQM34QBB8IWa9B .nofwYrL3vQdajEnlJsL0 input,
.PY6eGbwQM34QBB8IWa9B .nofwYrL3vQdajEnlJsL0 .C08Kli7n1w_igVhYcVoP {
  background-color: rgb(50, 50, 50) !important;
  width: 100%;
  font-size: 18px !important;
  padding: 10px 4px;
  color: #fff !important; /* Ensure text is white */
  caret-color: #fff; /* Make cursor white too */
}
.PY6eGbwQM34QBB8IWa9B .nofwYrL3vQdajEnlJsL0 input:disabled,
.PY6eGbwQM34QBB8IWa9B .nofwYrL3vQdajEnlJsL0 .C08Kli7n1w_igVhYcVoP:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background-color: rgba(255, 255, 255, 0.05);
}
.PY6eGbwQM34QBB8IWa9B .nofwYrL3vQdajEnlJsL0 .C08Kli7n1w_igVhYcVoP {
  resize: none;
  border: none;
  outline: none;
  min-height: 40px;
  max-height: 320px;
  line-height: 1.4;
  font-family: inherit;
  box-sizing: border-box; /* Ensure padding is included in height calculations */
  transition: height 0.1s ease; /* Smooth height transitions */
}
.PY6eGbwQM34QBB8IWa9B .nofwYrL3vQdajEnlJsL0 .eOksW9rCGkTUXiiJDMqy {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}
.PY6eGbwQM34QBB8IWa9B .nofwYrL3vQdajEnlJsL0 .eOksW9rCGkTUXiiJDMqy .M8pUSItpQJ1Pj9Fneddz {
  display: flex;
  gap: 8px;
  justify-content: flex-start;
  flex-grow: 1;
}
.PY6eGbwQM34QBB8IWa9B .nofwYrL3vQdajEnlJsL0 .eOksW9rCGkTUXiiJDMqy .XQzul2CvEH0i_51QvFBw {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}
.PY6eGbwQM34QBB8IWa9B .nofwYrL3vQdajEnlJsL0 .eOksW9rCGkTUXiiJDMqy .o6jxE4eW8PuRs21LlPbY {
  background-color: transparent;
  color: #fff;
  border: 1px solid #6439ab;
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.PY6eGbwQM34QBB8IWa9B .nofwYrL3vQdajEnlJsL0 .eOksW9rCGkTUXiiJDMqy .o6jxE4eW8PuRs21LlPbY:hover {
  background-color: rgba(100, 57, 171, 0.1);
}
.PY6eGbwQM34QBB8IWa9B .nofwYrL3vQdajEnlJsL0 .eOksW9rCGkTUXiiJDMqy .o6jxE4eW8PuRs21LlPbY:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  border-color: #7d7d7d;
  color: #777;
}
.PY6eGbwQM34QBB8IWa9B .nofwYrL3vQdajEnlJsL0 .eOksW9rCGkTUXiiJDMqy .doN433R2xIV80_BsJYNO {
  background-color: #6439df;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.PY6eGbwQM34QBB8IWa9B .nofwYrL3vQdajEnlJsL0 .eOksW9rCGkTUXiiJDMqy .doN433R2xIV80_BsJYNO:hover {
  background-color: #5b37c0;
}
.PY6eGbwQM34QBB8IWa9B .nofwYrL3vQdajEnlJsL0 .eOksW9rCGkTUXiiJDMqy .doN433R2xIV80_BsJYNO:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.PY6eGbwQM34QBB8IWa9B .nofwYrL3vQdajEnlJsL0 .eOksW9rCGkTUXiiJDMqy .doN433R2xIV80_BsJYNO:active {
  background-color: #543e79;
}
.PY6eGbwQM34QBB8IWa9B .nofwYrL3vQdajEnlJsL0 .eOksW9rCGkTUXiiJDMqy .mnIw4EIc85vBdJRcuK1M {
  background: none;
  border: none;
  cursor: pointer;
  color: #777;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 4px;
}
.PY6eGbwQM34QBB8IWa9B .nofwYrL3vQdajEnlJsL0 .eOksW9rCGkTUXiiJDMqy .mnIw4EIc85vBdJRcuK1M:hover {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.1);
}
.PY6eGbwQM34QBB8IWa9B .nofwYrL3vQdajEnlJsL0 .eOksW9rCGkTUXiiJDMqy .mnIw4EIc85vBdJRcuK1M:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.PY6eGbwQM34QBB8IWa9B .nofwYrL3vQdajEnlJsL0 .eOksW9rCGkTUXiiJDMqy .POkRKu6Ar1MWMl5_yCr1:hover {
  color: #44ff44;
}

.L65pxEr8PlVkWUaVkPjQ {
  position: relative;
}
.L65pxEr8PlVkWUaVkPjQ h1,
.L65pxEr8PlVkWUaVkPjQ h2,
.L65pxEr8PlVkWUaVkPjQ h3,
.L65pxEr8PlVkWUaVkPjQ h4,
.L65pxEr8PlVkWUaVkPjQ h5,
.L65pxEr8PlVkWUaVkPjQ h6 {
  margin-top: 1em;
  margin-bottom: 0.5em;
  font-weight: bold;
}
.L65pxEr8PlVkWUaVkPjQ h1 {
  font-size: 1.8em;
}
.L65pxEr8PlVkWUaVkPjQ h2 {
  font-size: 1.5em;
}
.L65pxEr8PlVkWUaVkPjQ h3 {
  font-size: 1.3em;
}
.L65pxEr8PlVkWUaVkPjQ h4 {
  font-size: 1.2em;
}
.L65pxEr8PlVkWUaVkPjQ ul,
.L65pxEr8PlVkWUaVkPjQ ol {
  padding-left: 1.5em;
  margin: 0.5em 0;
}
.L65pxEr8PlVkWUaVkPjQ li {
  margin: 0.25em 0;
}
.L65pxEr8PlVkWUaVkPjQ p {
  margin: 0.5em 0;
}
.L65pxEr8PlVkWUaVkPjQ strong {
  font-weight: bold;
}
.L65pxEr8PlVkWUaVkPjQ em {
  font-style: italic;
}
.L65pxEr8PlVkWUaVkPjQ code {
  background-color: rgba(0, 0, 0, 0.1);
  padding: 0.2em 0.4em;
  border-radius: 3px;
  font-family: monospace;
}
.L65pxEr8PlVkWUaVkPjQ pre {
  background-color: rgba(0, 0, 0, 0.1);
  padding: 1em;
  border-radius: 5px;
  overflow-x: auto;
}
.L65pxEr8PlVkWUaVkPjQ pre code {
  background-color: transparent;
  padding: 0;
}
.L65pxEr8PlVkWUaVkPjQ blockquote {
  border-left: 4px solid #ccc;
  padding-left: 1em;
  margin: 0.5em 0;
  color: #666;
}
.L65pxEr8PlVkWUaVkPjQ table {
  border-collapse: collapse;
  margin: 1em 0;
}
.L65pxEr8PlVkWUaVkPjQ table th,
.L65pxEr8PlVkWUaVkPjQ table td {
  border: 1px solid #ccc;
  padding: 0.5em;
}
.L65pxEr8PlVkWUaVkPjQ table th {
  background-color: rgba(0, 0, 0, 0.05);
}
.L65pxEr8PlVkWUaVkPjQ .oKzGQVKeUdtYeZ0CaeDK {
  position: absolute;
  bottom: 8px;
  right: 8px;
  opacity: 0;
}
.L65pxEr8PlVkWUaVkPjQ .oKzGQVKeUdtYeZ0CaeDK .QnU57SAPoP1BZZJgGt9s {
  display: flex;
  align-items: center;
  gap: 4px;
  border: 1px solid #444;
  font-size: 12px;
  padding: 4px 8px;
  backdrop-filter: blur(3px);
  border-radius: 4px;
  cursor: pointer;
}
.L65pxEr8PlVkWUaVkPjQ .oKzGQVKeUdtYeZ0CaeDK .QnU57SAPoP1BZZJgGt9s:hover {
  background-color: rgba(0, 0, 0, 0.3);
}
.L65pxEr8PlVkWUaVkPjQ .oKzGQVKeUdtYeZ0CaeDK .QnU57SAPoP1BZZJgGt9s:active {
  background-color: rgba(0, 0, 0, 0.4);
}
.L65pxEr8PlVkWUaVkPjQ .oKzGQVKeUdtYeZ0CaeDK .QnU57SAPoP1BZZJgGt9s svg {
  width: 14px;
  height: 14px;
}
.L65pxEr8PlVkWUaVkPjQ:hover .oKzGQVKeUdtYeZ0CaeDK {
  opacity: 1;
}

.F9n61ZWiyASVj99FeXCM {
  position: relative;
}
.F9n61ZWiyASVj99FeXCM .r3Od3Ak_iO1xhSxebGeg {
  position: absolute;
  top: 57px;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
  border-radius: 0 0 12px 12px; /* Only round the bottom corners */
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.F9n61ZWiyASVj99FeXCM .r3Od3Ak_iO1xhSxebGeg:hover {
  background: rgba(0, 0, 0, 0.4);
}
.F9n61ZWiyASVj99FeXCM .r3Od3Ak_iO1xhSxebGeg:active {
  background: rgba(0, 0, 0, 0.3);
}
.F9n61ZWiyASVj99FeXCM .r3Od3Ak_iO1xhSxebGeg .nfLPdQC7MOqcbOGxXjdA {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(119, 77, 238, 0.9);
  transition: all 0.2s ease;
  padding: 8px 16px;
  border-radius: 8px;
  color: white;
  font-weight: 500;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.F9n61ZWiyASVj99FeXCM .r3Od3Ak_iO1xhSxebGeg .nfLPdQC7MOqcbOGxXjdA:hover {
  background: rgb(119, 77, 238);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.F9n61ZWiyASVj99FeXCM .r3Od3Ak_iO1xhSxebGeg .nfLPdQC7MOqcbOGxXjdA:active {
  background: rgb(107, 69, 214);
  transform: translateY(0);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}
.F9n61ZWiyASVj99FeXCM .r3Od3Ak_iO1xhSxebGeg .nfLPdQC7MOqcbOGxXjdA span[role=img] {
  font-size: 16px;
}

/* Snapshot component styles */
.NRuk1JyXU6kdJAJ0AQ3Y {
  margin: 10px 0;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.NdrtuuB5_gkTCZvkcFWc {
  font-weight: 500;
  margin-bottom: 8px;
  color: #cccccc;
  text-align: center;
}

.qzXiKibeyGZiCOp2qk8l {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 4px;
  position: relative;
}

.P4z8D33ua7goHNPGNoRR {
  max-width: 100%;
  max-height: 400px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.x9XA6CBczlvjeM0COh91 {
  position: absolute;
  bottom: 8px;
  right: 8px;
  display: flex;
  gap: 8px;
  opacity: 0;
}

.mnIw4EIc85vBdJRcuK1M {
  margin-left: 8px;
  padding: 4px;
  background: none;
  border: none;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.2s ease;
}
.mnIw4EIc85vBdJRcuK1M:hover {
  opacity: 1;
}
.mnIw4EIc85vBdJRcuK1M:hover svg path {
  stroke: #44ff44;
}
.mnIw4EIc85vBdJRcuK1M:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
.mnIw4EIc85vBdJRcuK1M:disabled:hover svg path {
  stroke: inherit;
}

.iZfGZEul4Yp2h5kxCeNw {
  background: rgba(0, 0, 0, 0.5);
  border: none;
  border-radius: 4px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.2s ease;
  padding: 0;
}
.iZfGZEul4Yp2h5kxCeNw svg {
  width: 20px;
  height: 20px;
}
.iZfGZEul4Yp2h5kxCeNw:hover {
  background: rgba(0, 0, 0, 0.7);
}

.qzXiKibeyGZiCOp2qk8l:hover .x9XA6CBczlvjeM0COh91 {
  opacity: 1;
}

.wuhussjRWOjanxnu2SCm {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}

.ZmQ7L66NsxcNzXFTAH4e {
  background-color: #373737;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}
.ZmQ7L66NsxcNzXFTAH4e p {
  margin: 10px 0 30px 0;
  color: #fff;
  text-align: center;
  font-size: 18px !important;
}
.ZmQ7L66NsxcNzXFTAH4e .th8idpb6jiod1cZvRwus {
  display: flex;
  justify-content: center;
  gap: 12px;
}
.ZmQ7L66NsxcNzXFTAH4e .th8idpb6jiod1cZvRwus button {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  font-size: 18px !important;
}
.ZmQ7L66NsxcNzXFTAH4e .th8idpb6jiod1cZvRwus button:first-child {
  background-color: #dc3545;
  color: #fff;
}
.ZmQ7L66NsxcNzXFTAH4e .th8idpb6jiod1cZvRwus button:first-child:hover {
  background-color: #bd2130;
}
.ZmQ7L66NsxcNzXFTAH4e .th8idpb6jiod1cZvRwus button:last-child {
  background-color: #444;
  color: #fff;
}
.ZmQ7L66NsxcNzXFTAH4e .th8idpb6jiod1cZvRwus button:last-child:hover {
  background-color: #393939;
}`, "",{"version":3,"sources":["webpack://./src/editor/components/scenegraph/AIChatPanel.module.scss","webpack://./src/editor/style/variables.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,SAAA;EACA,YAAA,EAAA,4CAAA;EACA,2BAAA,EAAA,2BAAA;EACA,UAAA,EAAA,qCAAA;AAAF;AAEE;EACE,kBAAA,EAAA,2CAAA;EACA,mBAAA,EAAA,qDAAA;EACA,YAAA;EACA,yEAAA;AAAJ;AACI;EACE,aAAA;AACN;;AAIA;EACE,eAAA;EACA,SAAA;EACA,YAAA,EAAA,wCAAA;EACA,2BAAA,EAAA,2BAAA;EACA,UAAA,EAAA,qCAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,uCAAA;EACA,2BAAA;EACA,kBAAA,EAAA,iCAAA;EACA,yBAAA;EACA,wCAAA;AADF;AAGE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;EACA,kBAAA;AADJ;AAGI;EACE,iBAAA;EACA,WC1BE;ED2BF,eAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA,EAAA,oCAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;EACA,uBAAA;EACA,oBAAA,EAAA,mDAAA;AADN;AAGM;EACE,oBAAA,EAAA,uCAAA;AADR;AAKI;EACE,2FAAA;EASA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,wCAAA;EACA,yCAAA;EACA,mBAAA;AAXN;AAaM;EACE,YAAA;AAXR;AAeI;EACE,aAAA;EACA,QAAA;EACA,iBAAA,EAAA,2BAAA;AAbN;AAeM;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,WC5DG;ED6DH,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;AAbR;AAeQ;EACE,WCrFF;EDsFE,0CAAA;AAbV;AAgBQ;EACE,YAAA;EACA,mBAAA;AAdV;AAkBM;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,WClFG;EDmFH,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AAhBR;AAkBQ;EACE,WC5GF;ED6GE,0CAAA;AAhBV;AAsBE;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AApBJ;AAuBE;EACE,kBAAA;EACA,iBAAA;EACA,WC9GO;ED+GP,kBAAA;AArBJ;AAwBE;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AAtBJ;AAyBE;EACE,aAAA;EACA,SAAA;EACA,eAAA;AAvBJ;AA0BE;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WClIO;EDmIP,iBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;AAxBJ;AA0BI;EACE,sBCtHS;EDuHT,WC7JE;ED8JF,kBC7IK;ADqHX;AA4BE;EACE,eAAA;EACA,WCnJO;EDoJP,kBAAA;EACA,cAAA;AA1BJ;AA6BE;EACE,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,WC7KI;ADkJR;AA6BI;EACE,oBAAA;EACA,yBCtLO;AD2Jb;AA8BI;EACE,sBAAA;EACA,sBChJS;EDiJT,WAAA;EACA,8BAAA;EACA,kBAAA;AA5BN;AA8BM;EACE,0BAAA;AA5BR;AA+BM;EACE,0BAAA;AA7BR;AAgCM;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AA9BR;AAgCQ;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;AA9BV;AAgCU;EACE,yBAAA;AA9BZ;AAiCU;EACE,yBAAA;AA/BZ;AAmCQ;EACE,iBAAA;EACA,yBCzOG;ED0OH,WC7NF;ED8NE,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAjCV;AAmCU;EACE,yBCjPC;ADgNb;AAoCU;EACE,aAAA;EACA,gDAAA;AAlCZ;AAqCU;EACE,yBCxPC;ADqNb;AAwCM;EACE,eAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;AAtCR;AA0CI;EACE,sBAAA;EACA,sBCzOE;ED0OF,WAAA;EACA,kBAAA;AAxCN;AA0CM;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,wCAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAxCR;AA0CQ;EACE,WAAA;EACA,YAAA;EACA,WCtRF;AD8OR;AA8CE;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,6BAAA;EACA,QAAA;EACA,iCAAA;AA5CJ;AA8CI;;EAEE,4CAAA;EACA,WAAA;EACA,0BAAA;EACA,iBAAA;EACA,sBAAA,EAAA,yBAAA;EACA,iBC3SE,ED2S6B,0BAAA;AA5CrC;AA8CM;;EACE,YAAA;EACA,mBAAA;EACA,2CAAA;AA3CR;AA+CI;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,sBAAA,EAAA,sDAAA;EACA,4BAAA,EAAA,8BAAA;AA7CN;AAgDI;EACE,aAAA;EACA,8BAAA;EACA,QAAA;AA9CN;AAgDM;EACE,aAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;AA9CR;AAiDM;EACE,aAAA;EACA,QAAA;EACA,yBAAA;AA/CR;AAkDM;EACE,6BAAA;EACA,WCpVA;EDqVA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;AAhDR;AAkDQ;EACE,yCAAA;AAhDV;AAmDQ;EACE,YAAA;EACA,mBAAA;EACA,qBC/UC;EDgVD,WClVC;ADiSX;AAqDM;EACE,yBCrXK;EDsXL,WCzWA;ED0WA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;AAnDR;AAqDQ;EACE,yBC7XG;AD0Ub;AAsDQ;EACE,YAAA;EACA,mBAAA;AApDV;AAuDQ;EACE,yBCpYG;AD+Ub;AAyDM;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,WCjXG;EDkXH,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;AAvDR;AAyDQ;EACE,WC1YF;ED2YE,0CAAA;AAvDV;AA0DQ;EACE,YAAA;EACA,mBAAA;AAxDV;AA6DQ;EACE,cAAA;AA3DV;;AAkEA;EACE,kBAAA;AA/DF;AAgEE;;;;;;EAME,eAAA;EACA,oBAAA;EACA,iBAAA;AA9DJ;AAiEE;EACE,gBAAA;AA/DJ;AAiEE;EACE,gBAAA;AA/DJ;AAiEE;EACE,gBAAA;AA/DJ;AAiEE;EACE,gBAAA;AA/DJ;AAkEE;;EAEE,mBAAA;EACA,eAAA;AAhEJ;AAmEE;EACE,gBAAA;AAjEJ;AAoEE;EACE,eAAA;AAlEJ;AAqEE;EACE,iBAAA;AAnEJ;AAsEE;EACE,kBAAA;AApEJ;AAuEE;EACE,oCAAA;EACA,oBAAA;EACA,kBAAA;EACA,sBAAA;AArEJ;AAwEE;EACE,oCAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAtEJ;AAwEI;EACE,6BAAA;EACA,UAAA;AAtEN;AA0EE;EACE,2BAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;AAxEJ;AA2EE;EACE,yBAAA;EACA,aAAA;AAzEJ;AA2EI;;EAEE,sBAAA;EACA,cAAA;AAzEN;AA4EI;EACE,qCAAA;AA1EN;AA8EE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;AA5EJ;AA8EI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;EACA,eAAA;AA5EN;AA8EM;EACE,oCAAA;AA5ER;AA+EM;EACE,oCAAA;AA7ER;AAgFM;EACE,WAAA;EACA,YAAA;AA9ER;AAoFI;EACE,UAAA;AAlFN;;AAuFA;EACE,kBAAA;AApFF;AAsFE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,0BAAA;EACA,4BAAA,EAAA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,eAAA;EACA,sCAAA;AApFJ;AAsFI;EACE,8BAAA;AApFN;AAuFI;EACE,8BAAA;AArFN;AAwFI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mCAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,wCAAA;AAtFN;AAwFM;EACE,6BAAA;EACA,2BAAA;EACA,wCAAA;AAtFR;AAyFM;EACE,6BAAA;EACA,wBAAA;EACA,wCAAA;AAvFR;AA0FM;EACE,eAAA;AAxFR;;AA8FA,8BAAA;AACA;EACE,cAAA;EACA,qCAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AA3FF;;AA8FA;EACE,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AA3FF;;AA8FA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AA3FF;;AA8FA;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,wCAAA;AA3FF;;AA8FA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,QAAA;EACA,UAAA;AA3FF;;AA8FA;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,6BAAA;AA3FF;AA6FE;EACE,UAAA;AA3FJ;AA6FI;EACE,eAAA;AA3FN;AA+FE;EACE,YAAA;EACA,mBAAA;AA7FJ;AA+FI;EACE,eAAA;AA7FN;;AAkGA;EACE,8BAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,sCAAA;EACA,UAAA;AA/FF;AAiGE;EACE,WAAA;EACA,YAAA;AA/FJ;AAkGE;EACE,8BAAA;AAhGJ;;AAoGA;EACE,UAAA;AAjGF;;AAoGA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AAjGF;;AAoGA;EACE,yBC7pBa;ED8pBb,aAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,yCAAA;AAjGF;AAmGE;EACE,qBAAA;EACA,WC9sBI;ED+sBJ,kBAAA;EACA,0BAAA;AAjGJ;AAoGE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AAlGJ;AAoGI;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;AAlGN;AAoGM;EACE,yBAAA;EACA,WCluBA;ADgoBR;AAoGQ;EACE,yBAAA;AAlGV;AAsGM;EACE,sBCpsBO;EDqsBP,WC3uBA;ADuoBR;AAsGQ;EACE,yBCzsBK;ADqmBf","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"aiChatToggle": `ndD2Hv255jMaUjfb2tYY`,
	"isOpen": `uSRJ0eD0npEBtIgomBuR`,
	"chatContainer": `PY6eGbwQM34QBB8IWa9B`,
	"chat-header": `i_yNxSMXg3jy8JH7kLbJ`,
	"chat-title": `vn0Z4bNtPCd71HvPvRbR`,
	"betaPill": `Fk4ZtKavXiNu2dwJ_N2g`,
	"chat-actions": `mhstdJXT57e5ZIF0SKVw`,
	"reset-button": `pfn6leN0LQiC25LxR1ry`,
	"closeButton": `nOBt54z9z6rhSpkXl9pR`,
	"chatMessages": `Puob5KTyHUxauLdnwFMc`,
	"loadingIndicator": `Qd2Bcj_mr_4KIGSaSbYk`,
	"ratingContainer": `KIgWYQKpNYZJz4JsOC6M`,
	"ratingButtons": `VTY2fSdm1pm7dRzrjNNF`,
	"ratingButton": `N7ljWca7xPK98VWJFS6P`,
	"ratingFeedback": `lraVT_jJPAhnCGn1ChWI`,
	"chatMessage": `e1x3XsUIgyZXD_QOB50m`,
	"user": `XM6n1YQJaSlAM5MklYwe`,
	"functionCall": `FgjQogkx9AwKL5ABxXAp`,
	"success": `DjScRZmvL98UHvStTiU8`,
	"error": `HT4UXRcnyFzp57UHThem`,
	"functionCallSummary": `IENmtTuhJMMoD8ojAFi2`,
	"statusIndicator": `Ro_god6fZZEqzoV_Cag7`,
	"editLocationButton": `TLZG_Wk4hQlqAxreJWGI`,
	"functionCallDetails": `iSAZRnvlo9lr7XxWA223`,
	"assistant": `HCNJGaL5OeiE5BKGyreE`,
	"assistantAvatar": `d0cMPLprvuxq6fn1bWXB`,
	"chatInput": `nofwYrL3vQdajEnlJsL0`,
	"chatTextarea": `C08Kli7n1w_igVhYcVoP`,
	"actionButtons": `eOksW9rCGkTUXiiJDMqy`,
	"leftButtons": `M8pUSItpQJ1Pj9Fneddz`,
	"rightButtons": `XQzul2CvEH0i_51QvFBw`,
	"actionButton": `o6jxE4eW8PuRs21LlPbY`,
	"sendButton": `doN433R2xIV80_BsJYNO`,
	"resetButton": `mnIw4EIc85vBdJRcuK1M`,
	"greenIcon": `POkRKu6Ar1MWMl5_yCr1`,
	"markdownContent": `L65pxEr8PlVkWUaVkPjQ`,
	"markdownFooter": `oKzGQVKeUdtYeZ0CaeDK`,
	"copyButton": `QnU57SAPoP1BZZJgGt9s`,
	"proFeaturesWrapper": `F9n61ZWiyASVj99FeXCM`,
	"proOverlay": `r3Od3Ak_iO1xhSxebGeg`,
	"proOverlayContent": `nfLPdQC7MOqcbOGxXjdA`,
	"snapshotContainer": `NRuk1JyXU6kdJAJ0AQ3Y`,
	"snapshotCaption": `NdrtuuB5_gkTCZvkcFWc`,
	"snapshotImageWrapper": `qzXiKibeyGZiCOp2qk8l`,
	"snapshotImage": `P4z8D33ua7goHNPGNoRR`,
	"snapshotActions": `x9XA6CBczlvjeM0COh91`,
	"snapshotButton": `iZfGZEul4Yp2h5kxCeNw`,
	"resetConfirmModal": `wuhussjRWOjanxnu2SCm`,
	"resetConfirmContent": `ZmQ7L66NsxcNzXFTAH4e`,
	"resetConfirmButtons": `th8idpb6jiod1cZvRwus`
};
export default ___CSS_LOADER_EXPORT___;
